import { CompanyRepository } from "core/repository";
import { BasePresenter } from "core/presenter";

class GeographicInfoPresenter extends BasePresenter {
  initialState() {
    return {
      loading: false,
      company: null
    };
  }

  async onZipcodeChange() {
    const zipcode = this.viewModel.company.address.zipcode.replace(/\D/g, "");

    if (zipcode.length !== 8) {
      return;
    }

    this.viewModel.loading = true;

    const response = await CompanyRepository.getZipcodeInfo(zipcode);

    if (response.success) {
      const { address, fiscal_informations } = this.viewModel.company;
      address.neighborhood = response.neighborhood;
      address.street = response.address;
      address.city = response.city;
      address.state = response.state;
      fiscal_informations.municipal_code = response.cityCode;
      address.complement = response.addressAdditional;
    }

    this.viewModel.loading = false;
  }
}

export default GeographicInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/geographic-info/geographic-info.presenter.js